/**
 * @description table颗粒组件-联系用户erp
 * @param { userName: string | reactNode[姓名], userErp: string | reactNode[erp账号], showDoint:boolean[是否显示短线-] }
 * @returns 联系用户erp component or '-'
 */
import React from 'react';

export default function TableContactUser(props) {
  const { userName, userErp, showDoint = true } = props;

  return (
    <>
      {userName || userErp ? (
        <span className="table-contact-user-wrapper" style={{ display: 'flex' }}>
          <span
            className="table-contact-user-fa"
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              color: 'rgba(0, 0, 0, 0.65)',
              cursor: 'pointer',
            }}
            onClick={() => {
              if (userErp) {
                window.location.href = 'timline://chat/?topin=' + userErp;
              }
            }}
          >
            <span
              className="table-contact-user-name"
              style={{
                marginRight: 4,
              }}
            >
              {userName || ''}
            </span>
            <span className="table-contact-user-open-dongdong">
              <img
                style={{ width: '20px', height: '100%' }}
                src="//img30.360buyimg.com/pop/jfs/t1/145304/26/22937/1574/61f4a6caE1a49f93b/b2805f3e8b56e608.png"
              />
            </span>
          </span>
        </span>
      ) : (
        <>{showDoint ? '-' : ''}</>
      )}
    </>
  );
}
